import React, { useContext, useEffect, useState } from 'react'
import styled from 'styled-components';
import { DilContext } from '../ContextDil';


const SCItemEl = styled.div`
  border-radius: 10px;
  background-image: url(${props => props.background});
  background-size: 100% 100%;
  background-repeat: no-repeat;
  
  display:flex;
  align-items: flex-end; 
  cursor: pointer;
  box-shadow: 0 8px 8px rgba(0,0,0,0.35);
  

  
  min-width: 150px;
  min-height:120px;
 

  transition: background-size 0.4s;
  &:hover {
    background-size: 105% 105%;
  }
  @media screen and (max-width: 280px) {
    min-width: 100px;
    min-height:90px;
    }
 
`;
   
    
const Yazi = styled.div`
height: 40px;
width:100%;
display:flex;
align-items: center;
justify-content: center;
text-align: center;
border-bottom-left-radius: 10px;
border-bottom-right-radius: 10px;


line-height: 0.8rem;
background: rgba(0, 0, 0, 0.254);
color: white;
font-size: 14px;
font-weight: 800;

@media screen and (max-width: 280px) {
  font-size: 12px;
    }
`;


const CategoryItems = ({ id,res,ind,setProducts }) => {
 const [resim, setResim] = useState("");
 const {lang} =useContext(DilContext);
 const url = "https://1zw31qczi7.execute-api.eu-central-1.amazonaws.com/prod/category_pictures/"+id+"/"+res.CATEGORY;
 useEffect(() => {

 
    
    fetch(url)
    .then((data) => {data.text().then(
      text => setResim(text))});
    }, [url]);


  return (
    <SCItemEl
    onClick={()=>setProducts(ind)} 
    background={resim}>
       { (lang==="en") ?
      <Yazi>{res.CATEGORY_ING}</Yazi>
      :
      <Yazi>{res.CATEGORY}</Yazi>
  }
    </SCItemEl>
  )
}

export default CategoryItems
